import axios from "axios";
import {
  LAPORAN_AKHIR_GENERATE_FAIL,
  LAPORAN_AKHIR_GENERATE_REQUEST,
  LAPORAN_AKHIR_GENERATE_RESET,
  LAPORAN_AKHIR_GENERATE_SUCCESS,
  LAPORAN_AKHIR_GET_FAIL,
  LAPORAN_AKHIR_GET_REQUEST,
  LAPORAN_AKHIR_GET_RESET,
  LAPORAN_AKHIR_GET_SUCCESS,
} from "../constants/laporanAkhirConstants";
import {
  API_LAPORAN_AKHIR_GENERATE,
  API_LAPORAN_AKHIR_GET,
  API_LAPORAN_AKHIR_GET_DOWNLOAD,
  API_LAPORAN_AKHIR_GET_DOWNLOAD_PDF,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetLaporanAkhir =
  ({ tahun, bulan, outlet, namaOutlet = "" }) =>
  async (dispatch, getState) => {
    let fileName = "Laporan Akhir " + namaOutlet + ".xlsx";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_LAPORAN_AKHIR_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        tahun: tahun,
        bulan: bulan,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const DownloadPdfGetLaporanAkhir =
  ({ tahun, bulan, outlet, namaOutlet = "" }) =>
  async (dispatch, getState) => {
    let fileName = "Laporan Laporan Akhir " + namaOutlet + ".pdf";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_LAPORAN_AKHIR_GET_DOWNLOAD_PDF,
      method: "GET",
      responseType: "blob", // important
      params: {
        tahun: tahun,
        bulan: bulan,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetLaporanAkhir =
  ({ tahun, bulan, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: LAPORAN_AKHIR_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tahun: tahun,
          bulan: bulan,
          outlet: outlet,
        },
      };
      const { data: data } = await axios.get(API_LAPORAN_AKHIR_GET, config);
      console.log("testing Action get laporan akhir", data);
      dispatch({
        type: LAPORAN_AKHIR_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: LAPORAN_AKHIR_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetLaporanAkhir = () => async (dispatch, getState) => {
  dispatch({
    type: LAPORAN_AKHIR_GET_RESET,
  });
};

export const GenerateLaporanAkhir =
  ({ tahun, bulan, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: LAPORAN_AKHIR_GENERATE_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data: data } = await axios.post(
        API_LAPORAN_AKHIR_GENERATE,
        {
          tahun: tahun,
          bulan: bulan,
          outlet: outlet,
        },
        config
      );
      dispatch({
        type: LAPORAN_AKHIR_GENERATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }

      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: LAPORAN_AKHIR_GENERATE_FAIL,
        payload: message,
      });
    }
  };

export const RGenerateLaporanAkhir = () => async (dispatch, getState) => {
  dispatch({
    type: LAPORAN_AKHIR_GENERATE_RESET,
  });
};
